export function removeBootLoader() {
  document.getElementById("boot-loader")?.remove();
}
